import { createContext } from 'solid-js';
import { Server } from './types';
import { Observable } from 'rxjs';

export const StreamContext = createContext<Observable<Server>>();
